import { Link } from "react-router-dom";
import '../../styles/member.css';
import React, { useEffect, useState } from 'react';
import HeaderFFF from '../../components/HeaderFFF'
import Header from '../../components/Header'
import Footer from "../../components/Footer";

export default function BurkeHeather() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1000);
      
          useEffect(() => {
              const handleResize = () => {
                  setIsMobile(window.innerWidth <= 991);
              };
      
              window.addEventListener('resize', handleResize);
              return () => window.removeEventListener('resize', handleResize);
          }, []);
      
          return(
              <>
              {isMobile ? <Header /> : <HeaderFFF />}
        <div id="team-header-container">
            <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <h2>Burke Heather</h2>
            <svg xmlns="http://www.w3.org/2000/svg" width="102" height="2" viewBox="0 0 102 2" fill="none">
                <path d="M101 1H1" stroke="#BF9874" stroke-width="2" stroke-linecap="round"/>
            </svg>
        </div>
        <div className="member-container">
            <div className="member-box">
                <div className="member-photo">
                    <img src="https://t4.ftcdn.net/jpg/00/65/77/27/360_F_65772719_A1UV5kLi5nCEWI0BNLLiFaBPEkUbv5Fv.jpg" alt="/"></img>
                    <div><p>Associate - Lawyer</p><p>(289) 588-1844</p><a href="mailto:bheather@clvlaw.ca">bheather@clvlaw.ca</a></div>
                    
                </div>
                <div className="member-info">
                    <p>Burke is an associate with specific emphasis in mortgage transaction for residential and commercial properties. He has also participated in a variety of complex corporate transactions, which included acquisitions, commercial real estate purchases and sales and private offerings.
<br/>
Since being called to the Ontario Bar in 2012, Burke has obtained experience in various areas of law, including litigation and corporate/commercial and securities law.
<br/>
Prior to obtaining his law degree, Burke worked in investment research for two leading global banks in Singapore and Hong Kong.
<br/><br/>
Burke is actively involved in the community as the Chair of Central West Specialized Developmental Services, an organization based in Oakville which provides residential and other support to individuals with developmental challenges. He also sits on the board of his condominium corporation.
<br/><br/>
Burke enjoys spending weekends working on his cottage north of Peterborough.</p>
                </div>
                <div className="member-info-box">
                     <div><h4>Practices</h4>
                                                        <ul>
                                                            <li><Link to="/fields-of-expertise/corporate-and-commercial-law">Corporate & Commercial</Link></li>
                                                            <li><Link to="/fields-of-expertise/real-estate">Real Estate</Link></li>    
                                                        </ul>
                                                        </div>
                                                        <div><h4>Education</h4>
                                                        <ul>
                                                            <li>B.A. (Hons.), University of Manitoba</li>
                                                            <li>M.A., Queen's University</li>
                                                            <li>J.D., University of Toronto</li>
                                                        </ul></div>
                                                        <div><h4>Qualification</h4>
                                                        <ul>
                                                            <li>Called to the Ontario Bar in 2012</li>
                                                        </ul></div>
                                                        <div><h4>Affiliations</h4>
                                                        <ul>
                                                            <li>Canadian Bar Association</li>
                                                            <li>Ontario Bar Association</li>
                                                            <li>Law Society of Ontario</li>
                                                        </ul></div>
                                                        <div><h4>Special Designations</h4>
                                                        <ul>
                                                            <li>Chartered Financial Analyst</li>
                                                        </ul></div>
                                                    </div>
            </div>
        </div>
        {/* nav buttons */}
            <div className="next-page-double-btn">
                <div className="next-page-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="17" viewBox="0 0 13 17" fill="none">
                        <path d="M0.840374 9.59939L10.1851 15.9612C11.3584 16.76 12.8873 15.9263 12.9941 14.4904C13.002 14.3844 12.9831 14.2785 12.9499 14.1776L10.961 8.13557L12.9499 2.09351C12.9831 1.99261 13.002 1.8867 12.9941 1.78077C12.8886 0.364848 11.397 -0.472328 10.2228 0.285009L0.878026 6.31197C-0.276088 7.05633 -0.296349 8.82552 0.840374 9.59939Z" fill="#BF9874"/>
                    </svg>
                    <p><Link to="/our-team/mick-vashishth">Mick Vashishth</Link></p>
                </div>
                <div className="next-page-btn">   
                    <p><Link to="/our-team/cathy-vashishth">Cathy Vashishth</Link></p>
                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="17" viewBox="0 0 13 17" fill="none">
                        <path d="M12.1596 6.33849L2.81487 0.29479C1.64616 -0.461075 0.12465 0.321745 0.00723972 1.67603C-0.00238562 1.78706 0.018628 1.89822 0.0551139 2.00352L2.03901 7.72912L0.055114 13.4547C0.018628 13.56 -0.00238987 13.6712 0.00725817 13.7822C0.123306 15.1176 1.60765 15.9038 2.77722 15.1872L12.122 9.46154C13.2761 8.7544 13.2963 7.07367 12.1596 6.33849Z" fill="#BF9874"/>
                    </svg>
                </div>
            </div>
    <Footer/>
    </>
  );
}